import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import router from '@/router'

Vue.use(Vuex)

// const mainurl = 'http://192.168.1.105:8000';
const mainurl = 'https://appapi.akambc.com';

let state = {
    articles: [],
    catalogs: [],
    media: [],
    academy: [],
    posts: [],
}

const mutations = {
    nothing(){},

    article_list(state , articles){
        Vue.set(state, 'articles', articles);
        Vue.set(state, 'articles', [...articles]);
    },

    add_article(state, article){
        state.articles.unshift(article)
    },

    edit_article(state, payload){
        const item = state.articles.find(item => item.id === payload.id);
        Object.assign(item, payload);
    },

    delete_article(state, id){
        const itemIndex = state.articles.findIndex(item => item.id === id);
        state.articles.splice(itemIndex , 1);
    },

    catalog_list(state , catalogs){
        Vue.set(state, 'catalogs', catalogs);
        Vue.set(state, 'catalogs', [...catalogs]);
    },

    add_catalog(state, catalog){
        state.catalogs.unshift(catalog)
    },

    edit_catalog(state, payload){
        const item = state.catalogs.find(item => item.id === payload.id);
        Object.assign(item, payload);
    },

    delete_catalog(state, id){
        const itemIndex = state.catalogs.findIndex(item => item.id === id);
        state.catalogs.splice(itemIndex , 1);
    },

    media_list(state , media){
        Vue.set(state, 'media', media);
        Vue.set(state, 'media', [...media]);
    },

    add_media(state, media){
        state.media.unshift(media)
    },

    edit_media(state, payload){
        const item = state.media.find(item => item.id === payload.id);
        Object.assign(item, payload);
    },

    delete_media(state, id){
        const itemIndex = state.media.findIndex(item => item.id === id);
        state.media.splice(itemIndex , 1);
    },

    academy_list(state , academy){
        Vue.set(state, 'academy', academy);
        Vue.set(state, 'academy', [...academy]);
    },

    add_academy(state, academy){
        state.academy.unshift(academy)
    },

    edit_academy(state, payload){
        const item = state.academy.find(item => item.id === payload.id);
        Object.assign(item, payload);
    },

    delete_academy(state, id){
        const itemIndex = state.academy.findIndex(item => item.id === id);
        state.academy.splice(itemIndex , 1);
    },

}

const actions = {
    getPosts({ dispatch, commit }, type){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/posts/${type}`, method: 'GET' })
            .then(res => {
                if(type == 'article'){
                    commit("article_list", res.data)
                }
                else if(type == 'catalog'){
                    commit("catalog_list", res.data)
                }
                else if(type == 'media'){
                    commit("media_list", res.data)
                }
                else if(type == 'academy'){
                    commit("academy_list", res.data)
                }
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    addPost({ dispatch, commit }, post ){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/newPost`, data: post, method: 'post', headers: {
                'Authorization' : `Bearer ${localStorage.token}`,
                'Content-Type': 'multipart/form-data'
            } })
            .then(res => {
                if(res.data.data.type == 'article'){
                    commit("add_article", res.data.data)
                }
                else if(res.data.data.type == 'catalog'){
                    commit("add_catalog", res.data.data)
                }
                else if(res.data.data.type == 'media'){
                    commit("add_media", res.data.data)
                }
                else if(res.data.data.type == 'academy'){
                    commit("add_academy", res.data.data)
                }
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    getPostInfo({ dispatch, commit }, id){
        commit('nothing')
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/post/${id}`, method: 'GET' })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    updatePostInfo({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            let id = localStorage.getItem('postId')
            axios({ url: `${mainurl}/api/admin/editPost/${id}`, data: payload, method: 'POST', headers: {
                'Authorization' : `Bearer ${localStorage.token}`,
                'Content-Type': 'multipart/form-data'
            } })
            .then(res => {
                if(res.data.data.type == 'article'){
                    commit("edit_article", res.data.data)
                }
                else if(res.data.data.type == 'catalog'){
                    commit("edit_catalog", res.data.data)
                }
                else if(res.data.data.type == 'media'){
                    commit("edit_media", res.data.data)
                }
                else if(res.data.data.type == 'academy'){
                    commit("edit_academy", res.data.data)
                }
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    deletePost({ dispatch, commit }, { id, type }){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/deletePost/${id}`, method: 'DELETE' })
            .then(res => {
                if(type == 'article'){
                    commit("delete_article", id)
                }
                else if(type == 'catalog'){
                    commit("delete_catalog", id)
                }
                else if(type == 'media'){
                    commit("delete_media", id)
                }
                else if(type == 'academy'){
                    commit("delete_academy", id)
                }
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    }

}

const modules = {
}

const getters = {
}

export default({
    state,
    mutations,
    actions,
    getters,
    modules,
    axios
})
